// extracted by mini-css-extract-plugin
export default {"container":"tournamentTables_container__GZR1A","linksWrapper":"tournamentTables_linksWrapper__EXVcU","linkWrapper":"tournamentTables_linkWrapper__o1MNk"};